import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HiPlus } from 'react-icons/hi';

const PricingComponent = () => {
    const plans = [
        {
            title: "Bathroom Deep Clean",
            price: "349",
            features: [
                "Tile Stain Removal",
                "Mirror Polishing",
                "Sanitary Sanitization"
            ],
            link: "/bathroom-cleaning"
        },
        {
            title: "Kitchen Restoration",
            price: "1,199",
            features: [
                "Deep degreasing",
                "Cabinet cleaning",
                "Chimney exterior sanitization"
            ],
            link: "/Kitchen-cleaning",
            isPopular: true
        },
        {
            title: "Premium Sofa Shine",
            price: "449",
            features: [
                "Shampooing",
                "Industrial Vacuuming",
                "Steam Sanitization"
            ],
            link: "/sofa-cleaning"
        }
    ];

    return (
        <div className="w-full max-w-6xl mx-auto space-y-10">
            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 pb-8 border-b border-primary/10">
                <div className="space-y-2">
                    <h3 className="text-4xl md:text-5xl font-heading font-black text-foreground">
                        Service <br />
                        <span className="text-primary italic font-serif">Selection</span>
                    </h3>
                </div>
            </div>

            {/* Horizontal List */}
            <div className="space-y-4">
                {plans.map((plan, index) => (
                    <div 
                        key={index}
                        className={`group relative flex flex-col lg:flex-row lg:items-center justify-between p-8 md:p-10 rounded-[2rem] transition-all duration-500 hover:shadow-2xl hover:shadow-primary/5 ${
                            plan.isPopular 
                            ? 'bg-primary text-white scale-[1.02] shadow-xl ring-1 ring-primary/20' 
                            : 'bg-white border border-primary/5 hover:border-primary/20'
                        }`}
                    >
                        {plan.isPopular && (
                            <span className="absolute -top-3 left-10 bg-accent text-accent-foreground text-[8px] font-black uppercase tracking-[0.2em] px-3 py-1 rounded-full shadow-lg">
                                Most Preferred
                            </span>
                        )}

                        <div className="lg:w-1/4 mb-6 lg:mb-0">
                            <h4 className={`text-2xl font-black ${plan.isPopular ? 'text-white' : 'text-foreground'}`}>
                                {plan.title}
                            </h4>
                        </div>

                        <div className="lg:w-1/3 mb-6 lg:mb-0">
                            <ul className={`text-sm leading-relaxed ${plan.isPopular ? 'text-white/70' : 'text-muted-foreground'} font-medium space-y-1`}>
                                {plan.features.map((feature, fIndex) => (
                                    <li key={fIndex}>{feature}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="flex items-center justify-between lg:justify-end lg:w-1/3 gap-10">
                            <div className="flex flex-col">
                                <span className={`text-4xl font-black ${plan.isPopular ? 'text-accent' : 'text-primary'}`}>
                                    ₹{plan.price}
                                </span>
                                <span className={`text-[10px] font-bold uppercase tracking-widest ${plan.isPopular ? 'text-white/50' : 'text-muted-foreground'}`}>
                                    Starting rate
                                </span>
                            </div>

                            <Link 
                                to={plan.link}
                                className={`flex items-center gap-3 px-8 py-4 rounded-2xl font-black uppercase tracking-widest text-[10px] transition-all ${
                                    plan.isPopular 
                                    ? 'bg-white text-primary hover:bg-accent hover:text-accent-foreground' 
                                    : 'bg-primary text-white hover:bg-primary/90'
                                } shadow-xl`}
                            >
                                <HiPlus size={14} />
                                Get Now
                            </Link>
                        </div>
                    </div>
                ))}
            </div>

            <p className="text-center text-xs text-muted-foreground font-medium italic pt-4">
                *Final pricing may vary based on specific site requirements and square footage.
            </p>
        </div>
    );
};

export default PricingComponent;

